import { render } from "./motion-select-button.vue?vue&type=template&id=018967a4"
import script from "./motion-select-button.vue?vue&type=script&lang=js"
export * from "./motion-select-button.vue?vue&type=script&lang=js"

import exportComponent from "/Users/ars62917/Dropbox/voteomatic/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__